import Heading from "../Components/Heading/Heading";
import LiContent from "../Components/LiContent/LiContent";
import Line from "../Components/Line/Line";
import RelatedT from "../Components/RelatedArticles/Related";
import ConvertButton from "../Components/ConvertButton";
import FAQComponent from "../Components/FAQComponent/FAQComponent";
import React from "react";


function Cloudinary() {
    const related = [
        {
        href: '/cloudinary',
        name: 'Cloudinary',
        side: 'partial support',
        text: 'Image CDNs help you serve the best image to users. Find out how you can use JPEG XL images in Cloudinary.'
        },
        {
            href: '/shimmercat',
            name: 'ShimmerCat',
            side: 'full support',
            text: 'Image CDNs help you serve the best image to users. Find out how you can use JPEG XL images in ShimmerCat.'
        }
        ]
    return (
        <>
            <Heading h='Cloudinary JPEG XL support' p='#tutorials'/>
            <article>
                <nav className='content_table'>
                    <h4>Table of Content</h4>
                    <ol className='content_ol'>
                        <LiContent n='1' a='#introduction' text='Introduction'/>
                        <LiContent n='2' a='#cloudinary-jxl-support' text='Cloudinary JXL support'/>
                    </ol>
                </nav>
                <br/>
                <Line/>

                <span id='introduction'>
                    <h1 className="main">Introduction</h1>
                    <p className='umain'>JPEG XL is a new codec offering lossless compression and lossy compression. With a focus on high-fidelity compression and progressive rendering, JPEG XL is specifically designed to deliver high-quality images over the web with significant file size reduction. Its efficient compression allows for small file size, and its progressive decoding enhances the web experience even more. The new image format is meant to replace the existing JPEG and other legacy formats like PNG. It even offers lossless transcoding in terms of full support for lossless JPEG recompression.</p>
                    <p className='umain'>With Cloudinary, you can manage every aspect of images and videos on your website or mobile application, including uploading, storing, manipulating, optimizing, and delivering them. Cloudinary lets you upload pictures and videos to the cloud and perform intelligent manipulations on those media without installing additional software. Your media is then delivered through Cloudinary's fast, industry-leading content delivery network (CDN). In addition, Cloudinary offers an API and administration interface that can be easily integrated with web and mobile applications.</p>
                    <p className='umain'>Without the need for a credit card, Cloudinary provides a free plan for life. Your usage is tracked through credits, with the free plan providing 25 credits. The funds can be used to purchase 25k transformations of images, 25GB of managed storage, or 25GB of bandwidth. Plans with higher prices provide more conversions, backups to your S3 bucket, automatic tagging for searching, and access to various add-ons.</p>
                    <p className='umain'>Cloudinary's mission has been to assist companies in unlocking the potential of all their media to achieve the most engaging visual experiences since its founding. As part of this effort, they support new codecs for images and videos quickly.</p>
                </span>
                <Line/>

                <span id='cloudinary-jxl-support'>
                    <h1 className="main">Cloudinary JXL support</h1>
                    <p className='umain'>Cloudinary plays a significant role in the development of and design of the image codec JPEG XL. It is no wonder they were the first CDN globally that supported this file format for their clients. As with any other file format, you can convert an image format to JPEG XL by changing the URL's file extension to JXL or adding the f_jxl parameter to the end of the URL.</p>
                    <p className='umain'>It will take some time before the f_auto function supports JXL, as browser support for the codec is currently lacking. When stable releases of browsers are available that support JPEG XL and regular website users can enjoy the benefits of JXL, Cloudinary will most likely convert images automatically. Luckily enough, the Chromium-based browsers Chrome, Opera, and Edge already have experimental support, even though it has to be enabled manually.</p>
                    <p className='umain'>If you own a Cloudinary account and would like to play around with JXL, we highly recommend trying out the automatic quality level with the q_auto parameter or setting different quality levels with q_number to test out what JPEG XL is capable of.</p>
                    <p className='umain'>The announcement of full support for JPEG XL in browsers and on Cloudinary is exciting. We hope that Cloudinary will continue to expand the ecosystem and advertising to speed up the adoption of the new file format.</p>
                </span>
                <Line/>

                <br/><FAQComponent/><br/>
                <RelatedT related={related}/>
            </article>


            <ConvertButton/>
            <br/>
        </>)
}

export default Cloudinary